import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import ml from "./locales/ml.json";
import hi from "./locales/hi.json";

export const SUPPORTED = [
  { code: "en", label: "English" },
  { code: "ml", label: "മലയാളം" },
  { code: "hi", label: "हिन्दी" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ml: { translation: ml },
      hi: { translation: hi },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "ml", "hi"],
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "semicon_lang",
    },
    interpolation: { escapeValue: false },
  });

// Keep <html lang="..."> in sync
document.documentElement.setAttribute("lang", i18n.language || "en");
i18n.on("languageChanged", (lng) => {
  document.documentElement.setAttribute("lang", lng);
});

export default i18n;
